import { IAuthSlice, IJobSlice, IJob, IJobPayload } from "redux/types";
import { AsyncThunk, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as api from "../../api/index";

const initialState: IJobSlice = {
    allJobsEn: [],
    allJobsTr: [],
    currentJob: undefined,
    isSendingApplication: false
};

type GetAllJobsThunk = AsyncThunk<IJob[], void, {}>

export const getAllJobs: GetAllJobsThunk = createAsyncThunk("job/getAllJobs", async () => {

    const { data } = await api.getAllJobsReq()

    return data.jobs
})

type GetJobByIdThunk = AsyncThunk<IJob, string, {}>

export const getJobById: GetJobByIdThunk = createAsyncThunk("job/getJobById", async (id) => {

    const { data } = await api.getJobByIdReq(id)


    return data.job[0]

})


type CreateNewJobThunk = AsyncThunk<IJob[], IJobPayload, {}>

export const createNewJob: CreateNewJobThunk = createAsyncThunk("job/createNewJob", async (payload) => {

    const { data } = await api.createNewJobReq(payload)

    return data.jobs

})

type UpdateJobThunk = AsyncThunk<IJob[], { id: string, jobPayload: any }, {}>

export const updateJob: UpdateJobThunk = createAsyncThunk("job/updateJob", async (payload) => {

    const { data } = await api.updateJobReq(payload.id, payload.jobPayload)

    return data.jobs
})

type DeleteJobThunk = AsyncThunk<IJob[], string, {}>

export const deleteJob: DeleteJobThunk = createAsyncThunk("job/deleteJob", async (id) => {

    const { data } = await api.deleteJobReq(id)

    return data.jobs
})

type SendApplicationThunk = AsyncThunk<void, any, {}>

export const sendApplication: SendApplicationThunk = createAsyncThunk("job/sendApplication", async (payload) => {
    await api.sendApplicationReq(payload)
})



const jobSlice = createSlice({
    name: "job",
    initialState,
    reducers: {

    },
    extraReducers(builder) {
        builder.addCase(getAllJobs.fulfilled, (state, action) => {
            const jobsTr = action.payload.filter((job) => job.lang === "tr")
            const jobsEn = action.payload.filter((job) => job.lang === "en")
            return {
                ...state,
                allJobsTr: jobsTr,
                allJobsEn: jobsEn
            }
        })
        builder.addCase(getJobById.fulfilled, (state, action) => {
            return {
                ...state,
                currentJob: action.payload
            }
        })
        builder.addCase(createNewJob.fulfilled, (state, action) => {
            return {
                ...state,
                allJobs: action.payload
            }
        })
        builder.addCase(updateJob.fulfilled, (state, action) => {
            return {
                ...state,
                allJobs: action.payload
            }
        })
        builder.addCase(deleteJob.fulfilled, (state, action) => {
            return {
                ...state,
                allJobs: action.payload
            }
        })
    }
})

export const { } = jobSlice.actions

export default jobSlice.reducer